"use strict";

import getServiceSet from "vfu/getServiceSet";
import sessionStore from "./../store/session";
import poiStore from "./../store/pois";
import poiModificationStore from "./../store/poiModifications";
import {pointToLatLng} from "./geo";

export default {
	getPrivilegeOfPOI,
	getServiceSetOfPOI,
	getTypeOfPOI,
	getNameOfPOI,
	getLocationOfPOI,
	getPathOfPOI,
	getCenterOfPOI,
	getRadiusOfPOI,
	getColorOfPOI,
	getBoundsOfPOI,
	getBoundsOfPolygonPOI,
	getBoundsOfRadialPOI,
	getModificationsOfPOI
};

export {getPrivilegeOfPOI as getPrivilegeOfPOI};
export {getServiceSetOfPOI as getServiceSetOfPOI};
export {getTypeOfPOI as getTypeOfPOI};
export {getNameOfPOI as getNameOfPOI};
export {getLocationOfPOI as getLocationOfPOI};
export {getPathOfPOI as getPathOfPOI};
export {getCenterOfPOI as getCenterOfPOI};
export {getRadiusOfPOI as getRadiusOfPOI};
export {getColorOfPOI as getColorOfPOI};
export {getBoundsOfPOI as getBoundsOfPOI};
export {getBoundsOfPolygonPOI as getBoundsOfPolygonPOI};
export {getBoundsOfRadialPOI as getBoundsOfRadialPOI};
export {getModificationsOfPOI as getModificationsOfPOI};

function getServiceSetOfPOI(poiId) {
	const session = sessionStore.get();
	if (!session) return null;
	
	const poi = poiStore.get(poiId);
	if (!poi) return null;
	
	const pois = poiStore.getAll();
	if (!pois) return null;
	
	return getServiceSet("POISet", "poi", session.user, poi, pois);
}

function getPrivilegeOfPOI(vehicleId) {
	const serviceSet = getServiceSetOfPOI(vehicleId);
	if (serviceSet && serviceSet.value && serviceSet.value.privilege !== undefined)
		return serviceSet.value.privilege;
	return null;
}

function getTypeOfPOI(poiId) {
	const poi = poiStore.get(poiId);
	if (!poi) return null;
	return poi.type || null;
}

function getNameOfPOI(poiId) {
	const poi = poiStore.get(poiId);
	if (!poi) return null;
	return poi.name || "";
}

function getLocationOfPOI(poiId) {
	const poi = poiStore.get(poiId);
	if (!poi) return null;
	const modifications = getModificationsOfPOI(poiId);
	return modifications.location || poi.location;
}

function getPathOfPOI(poiId) {
	const location = getLocationOfPOI(poiId);
	
	if (!location ||
		!location.coordinates ||
		!location.coordinates[0] ||
		!location.coordinates[0][0]
	) return null;
	
	// csak egyszeres poligonokkal, azok egyszeres nem ismétlődő gyűrűjével foglalkozunk
	const ring = location.coordinates[0][0];
	return ring.filter((_, i) => i != ring.length - 1).map(point => new google.maps.LatLng(point[1], point[0]));
}

function getCenterOfPOI(poiId) {
	const location = getLocationOfPOI(poiId);
	
	if (!location ||
		!location.coordinates ||
		location.coordinates.length != 2
	) return null;
	
	return pointToLatLng(location);
}

function getRadiusOfPOI(poiId) {
	const poi = poiStore.get(poiId);
	const modifications = getModificationsOfPOI(poiId);
	if (!poi || poi.type != "RadialPOI") return null;
	return modifications.radius || poi.radius;
}

function getColorOfPOI(poiId) {
	const poi = poiStore.get(poiId);
	if (!poi) return null;
	const modifications = getModificationsOfPOI(poiId);
	return modifications.color || (poi.color || DEFAULT_COLOR);
}

function getBoundsOfPOI(poiId) {
	const type = getTypeOfPOI(poiId);
	if (type == "PolygonalPOI")
		return getBoundsOfPolygonPOI(poiId);
	else if (type == "RadialPOI")
		return getBoundsOfRadialPOI(poiId);
	else return null;
}

function getBoundsOfPolygonPOI(poiId) {
	const path = getPathOfPOI(poiId);
	if (!path) return;
	const bounds = new google.maps.LatLngBounds();
	path.forEach(edge => bounds.extend(edge));
	return bounds;
}

function getBoundsOfRadialPOI(poiId) {
	const center = getCenterOfPOI(poiId);
	const radius = getRadiusOfPOI(poiId);
	if (!center || radius === null)
		return null;
	
	const offset = {
		lat: radius / 110540,
		lng: Math.abs(radius / 74213 / Math.cos(center.lat()))
	};
	
	const bounds = new google.maps.LatLngBounds();
	
	bounds.extend(new google.maps.LatLng(center.lat() + offset.lat, center.lng()));
	bounds.extend(new google.maps.LatLng(center.lat() - offset.lat, center.lng()));
	bounds.extend(new google.maps.LatLng(center.lat(), center.lng() + offset.lng));
	bounds.extend(new google.maps.LatLng(center.lat(), center.lng() - offset.lng));
	
	return bounds;
}

function getModificationsOfPOI(poiId) {
	return poiModificationStore.get(poiId) ? poiModificationStore.get(poiId).modifications : {};
}


// WEBPACK FOOTER //
// ./src/utils/poi.js